import { applyPromoOverride } from 'yoda-core-components/lib/helpers/Stylitics';
import { shopTheLookMiniPDPClickEvent } from 'yoda-site-components/lib/actions/AnalyticsAction';
import { miniPDPOnShopTheLookOpen } from 'yoda-site-components/lib/actions/MiniPDPAction';

let _onOutfitsLoaded = null;
let _onItemClick = null;

const featureShopsConfig = {
    id: 'feature-shops',
    containerId: 'stylitics-featured-shops-target',
    title: 'Feature Shops',
    featureFlagKey: 'enableFeatureShops',
    requiresItemNumber: false,

    getScriptURL: (prefs) => prefs?.featureShopURL || '',

    createWidget: async (itemNumber, featureFlags, params = {}) => {
        if (typeof stylitics === 'undefined' || !stylitics?.featured_shops?.core) {
            throw new Error('Stylitics Featured Shops SDK is not available');
        }
        const { slug, profileId, disableStyliticsColor, onOutfitClick, onShopView } = params;

        const instance = stylitics.featured_shops.core.start({
            'featured-shops-slug': slug,
            'stylitics-target-id': 'stylitics-featured-shops-target',
            'look-card-type': 'moodboard',
            'show-arrows-on-touch?': true,
            'next-item-peekable-factor': 0.25,
            customer: { profileId },
            routing: { 'use-fragment': false, 'use-head-title': false },
        });

        if (!disableStyliticsColor) {
            instance.on('item-mount', ({ item, element }) => {
                applyPromoOverride(element, item, ' with code');
            });
        }

        instance.on('bundle-mount', (data) => {
            _onOutfitsLoaded?.(data);
        });

        instance.onItemClick((item) => {
            _onItemClick?.(item, null);
        });

        instance.on('outfit-click', (data) => {
            onOutfitClick?.(data);
        });

        instance.on('shop-view', () => {
            onShopView?.();
        });

        return instance;
    },

    registerEvents: (instance, { onOutfitsLoaded, onItemClick }) => {
        _onOutfitsLoaded = onOutfitsLoaded;
        _onItemClick = onItemClick;
    },

    refresh: () => {},

    analyticsClickAction: ({ id, ppId, moduleName, linkPosition }) =>
        shopTheLookMiniPDPClickEvent({
            shopTheLookID: id?.toString() || '',
            shopTheLookPPID: ppId,
            moduleName,
            linkPosition,
        }),
    miniPDPAction: miniPDPOnShopTheLookOpen,
    analyticsModule: 'featured looks',
};

export default featureShopsConfig;
